(() => {
    "use strict";

    const STORAGE_KEYS = {
        RETURNING_POPUP_DISABLED: 'dontShowReturningPopup',
        LAST_VISITED_PRODUCT: 'lastVisitedProduct',
        SESSION_SHOWN_FIRST_TIME: 'firstTimePopupShownInSession',
        SESSION_SHOWN_RETURNING: 'returningPopupShownInSession'
    };

    // Check if we're on homepage
    function isHomepage() {
        const path = window.location.pathname;
        return path === '/' || path === '/en' || path === '/my' || path === '/index.php';
    }

    // Helper functions for product tracking
    function getLastVisitedProduct() {
        try {
            const product = localStorage.getItem(STORAGE_KEYS.LAST_VISITED_PRODUCT);
            return product ? JSON.parse(product) : null;
        } catch (error) {
            console.error('Error getting last visited product:', error);
            return null;
        }
    }

    function setLastVisitedProduct(product) {
        try {
            localStorage.setItem(STORAGE_KEYS.LAST_VISITED_PRODUCT, JSON.stringify(product));
        } catch (error) {
            console.error('Error storing last visited product:', error);
        }
    }

    function createProductCard(product) {
        return `
            <div class="bs-product-item">
                <a href="${product.url}">
                    <img class="bs-product-image" src="${product.image}" alt="${product.name}" loading="lazy">
                    <div class="bs-product-title">${product.name}</div>
                    <div class="bs-product-price">${product.price}</div>
                </a>
            </div>
        `;
    }

    // Show first-time visitor popup
    function showFirstTimeVisitorPopup(products) {
        if (!window.popupSettings?.firstTimePopup?.enabled || 
            sessionStorage.getItem(STORAGE_KEYS.SESSION_SHOWN_FIRST_TIME)) {
            return;
        }

        const modal = document.createElement('div');
        modal.className = 'bs-modal-backdrop';
        modal.innerHTML = `
            <div class="bs-modal-container">
                <button class="bs-modal-close-btn">&times;</button>
                <h2 class="bs-modal-heading">${window.popupSettings.firstTimePopup.heading}</h2>
                <div class="bs-bestseller-carousel">
                    ${products.map(createProductCard).join('')}
                </div>
                <div class="bs-modal-actions">
                    <button class="bs-modal-btn bs-modal-btn-primary">
                        ${window.popupSettings.firstTimePopup.buttonText}
                    </button>
                </div>
            </div>
        `;

        document.body.appendChild(modal);
        setTimeout(() => {
            modal.classList.add('show');
            
            if (typeof $.fn.slick === 'function') {
                $('.bs-bestseller-carousel').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    centerMode: false,
                    variableWidth: false,
                    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>',
                    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                });
            }
        }, 100);

        sessionStorage.setItem(STORAGE_KEYS.SESSION_SHOWN_FIRST_TIME, 'true');
        setupModalEventListeners(modal, 'firstTime');
    }

    // Show returning visitor popup
    function showReturningVisitorPopup(product) {
        if (!window.popupSettings?.returningPopup?.enabled || 
            localStorage.getItem(STORAGE_KEYS.RETURNING_POPUP_DISABLED) === 'true' ||
            sessionStorage.getItem(STORAGE_KEYS.SESSION_SHOWN_RETURNING)) {
            return;
        }

        const modal = document.createElement('div');
        modal.className = 'bs-modal-backdrop';
        modal.innerHTML = `
            <div class="bs-return-modal-container">
                <button class="bs-modal-close-btn">&times;</button>
                <h2 class="bs-modal-heading">${window.popupSettings.returningPopup.heading}</h2>
                <div class="bs-return-product">
                    <img class="bs-return-image" src="${product.image}" alt="${product.name}">
                    <div class="bs-return-details">
                        <div class="bs-return-title">${product.name}</div>
                        <div class="bs-return-price">${product.price}</div>
                        <button class="bs-return-btn">
                            ${window.popupSettings.returningPopup.buttonText}
                        </button>
                    </div>
                </div>
                <button class="bs-return-dismiss">Don't show this again</button>
            </div>
        `;

        document.body.appendChild(modal);
        setTimeout(() => modal.classList.add('show'), 100);
        sessionStorage.setItem(STORAGE_KEYS.SESSION_SHOWN_RETURNING, 'true');
        setupModalEventListeners(modal, 'returning');
    }

    // Setup modal event listeners
    function setupModalEventListeners(modal, type) {
        const closeBtn = modal.querySelector('.bs-modal-close-btn');
        closeBtn.addEventListener('click', () => {
            modal.classList.remove('show');
            setTimeout(() => modal.remove(), 300);
        });

        if (type === 'returning') {
            const viewProductBtn = modal.querySelector('.bs-return-btn');
            const dontShowBtn = modal.querySelector('.bs-return-dismiss');
            
            viewProductBtn.addEventListener('click', () => {
                const lastProduct = getLastVisitedProduct();
                if (lastProduct?.url) {
                    window.location.href = lastProduct.url;
                }
            });

            dontShowBtn.addEventListener('click', () => {
                localStorage.setItem(STORAGE_KEYS.RETURNING_POPUP_DISABLED, 'true');
                modal.classList.remove('show');
                setTimeout(() => modal.remove(), 300);
            });
        } else {
            const primaryBtn = modal.querySelector('.bs-modal-btn-primary');
            primaryBtn.addEventListener('click', () => {
                window.location.href = window.popupSettings.firstTimePopup.buttonUrl;
            });
        }
    }

    // Track product views
    function setupProductTracking() {
        // Function to extract product data from URL
        function extractProductData() {
            const currentUrl = window.location.href;
            if (currentUrl.includes('/products/')) {
                const productContainer = document.querySelector('.product-container, .product, [class*="product-template"]');
                if (productContainer) {
                    const productData = {
                        url: currentUrl,
                        name: productContainer.querySelector('h1, .product-title, .product-name')?.textContent?.trim(),
                        price: (() => {
                            const priceContainer = productContainer.querySelector('.price, .product-price');
                            if (!priceContainer) return '';
                            const discountedPrice = priceContainer.querySelector('ins .money')?.textContent?.trim();
                            return discountedPrice || priceContainer.querySelector('.money')?.textContent?.trim() || '';
                        })(),
                        image: (() => {
                            const zoomLink = productContainer.querySelector('.product-single__media-zoom');
                            return zoomLink?.href || productContainer.querySelector('img')?.src;
                        })()
                    };

                    if (productData.name) {
                        setLastVisitedProduct(productData);
                        return true;
                    }
                }
            }
            return false;
        }

        // Check if we're on a product page
        if (window.location.pathname.includes('/products/')) {
            const checkProduct = setInterval(() => {
                if (extractProductData()) {
                    clearInterval(checkProduct);
                }
            }, 500);
        }

        // Listen for clicks on product links
        document.addEventListener('click', function(e) {
            const productLink = e.target.closest('a[href*="/products/"]');
            if (productLink) {
                const productCard = productLink.closest('[class*="product"]');
                if (productCard) {
                    const productData = {
                        url: productLink.href,
                        name: productCard.querySelector('[class*="title"], [class*="name"]')?.textContent?.trim(),
                        price: (() => {
                            const priceContainer = productCard.querySelector('[class*="price"]');
                            if (!priceContainer) return '';
                            const discountedPrice = priceContainer.querySelector('ins .money')?.textContent?.trim();
                            return discountedPrice || priceContainer.querySelector('.money')?.textContent?.trim() || '';
                        })(),
                        image: (() => {
                            const zoomLink = productCard.querySelector('.product-single__media-zoom');
                            return zoomLink?.href || productCard.querySelector('img')?.src;
                        })()
                    };

                    if (productData.name && productData.url) {
                        setLastVisitedProduct(productData);
                    }
                }
            }
        });
    }

    // Initialize popup system
    async function initialize() {
        if (!window.popupSettings?.enabled || !isHomepage()) {
            return;
        }

        setupProductTracking();

        // Wait for 3 seconds before showing popup
        setTimeout(async () => {
            const lastVisitedProduct = getLastVisitedProduct();
            
            if (lastVisitedProduct && window.popupSettings.returningPopup.enabled) {
                showReturningVisitorPopup(lastVisitedProduct);
            } else if (window.popupSettings.firstTimePopup.enabled) {
                try {
                    // Fetch products from the selected collection
                    const collectionHandle = window.popupSettings.firstTimePopup.collection;
                    const response = await fetch(`/collections/${collectionHandle}/products.json?limit=10`);
                    const data = await response.json();
                    
                    const products = data.products.map(product => ({
                        name: product.title,
                        price: `From ${product.variants[0].price}`,
                        image: product.images[0].src,
                        url: `/products/${product.handle}`
                    }));

                    showFirstTimeVisitorPopup(products);
                } catch (error) {
                    console.error('Failed to fetch collection products:', error);
                }
            }
        }, 3000);
    }

    // Start initialization when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
})();
